module.exports = __webpack_public_path__ + "cb08677aaf925d5ca3c31a3acd88f804.pdf";